import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { PractitionerGroupsComponent } from './practitionerGroups.component';
import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { EditPractitionerGroupDialogModule } from '../../components/edit-practitioner-group-dialog/edit-practitioner-group-dialog.module';
import { DocumentsDialogModule } from '../../components/documents/documents-dialog.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DocumentsDialogModule,
        EditPractitionerGroupDialogModule,
        MatButtonModule,
        MatIconModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        PractitionerGroupsComponent,
    ],
    exports: [
        PractitionerGroupsComponent
    ]
})
export class PractitionerGroupsModule { }
